import { NgModule } from '@angular/core';
import { SetColorDirective } from './set-color.directive';
import { SetFocusDirective } from './set-focus.directive';
import { TextContrastDirective } from './text-contrast.directive';
import { CustomMinDirective } from './custom-min-validator.directive';
import { CustomMaxDirective } from './custom-max-validator.directive';
import { CustomMinDateDirective } from './custom-min-date-validator.directive';
import { CustomMaxDateDirective } from './custom-max-date-validator.directive';
import { CopyClipboardDirective } from './copy-clipboard-directive';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { TranslateDirective } from './translate.directive';
import { DateModule } from 'app/main/content/misc/date.module';
import { NoDblClickDirective } from './no-dblclick-directive';
import { ContenteditableValueAccessor } from './content-editable-value-accessor';

@NgModule({
    declarations: [
        SetFocusDirective,
        SetColorDirective,
        TextContrastDirective,
        CustomMinDirective,
        CustomMaxDirective,
        CustomMinDateDirective,
        CustomMaxDateDirective,
        CopyClipboardDirective,
        NumbersOnlyDirective,
        TranslateDirective,
        NoDblClickDirective,
        ContenteditableValueAccessor,
    ],
    imports: [
        DateModule,
    ],
    exports: [
        SetFocusDirective,
        SetColorDirective,
        TextContrastDirective,
        CustomMinDirective,
        CustomMaxDirective,
        CustomMinDateDirective,
        CustomMaxDateDirective,        
        CopyClipboardDirective,
        NumbersOnlyDirective,
        TranslateDirective,
        NumbersOnlyDirective,
        NoDblClickDirective,
        ContenteditableValueAccessor,
    ],
})
export class PhoenixDirectivesModule
{
}
